// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2RxkN","clinicsSelect":"TableHeading_clinicsSelect__89Fta"};